export default __webpack_public_path__ + "static/media/wix-step2.6f3f0e25.png";